/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-27 19:52:57
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-03-16 19:48:17
 * @FilePath: /knit-web/src/router/routes/modules/develop.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { DEFAULT_LAYOUT } from '@/router/constants';
import { AppRouteRecordRaw } from '../types';

const ROUTERS: AppRouteRecordRaw = {
  path: '/develop',
  name: 'Develop',
  component: DEFAULT_LAYOUT,
  redirect: '/develop/workflow',
  meta: {
    locale: 'menu.develop.title',
    requiresAuth: false,
    hideFirstMenu: true,
    order: 10,
  },
  children: [
    {
      path: 'workflow',
      name: 'WorkflowIndex',
      component: () => import('@/views/workflow/workflow-index.vue'),
      meta: {
        locale: 'menu.develop.workflow.index',
        requiresAuth: true,
        roles: ['*'],
        order: 10,
        icon: 'icon-my-workflow',
        iconColor: '#3E90F0',
      },
    },
    {
      path: 'workflow/detail',
      name: 'WorkflowDetail',
      component: () => import('@/views/workflow/workflow-detail.vue'),
      meta: {
        locale: 'menu.develop.workflow.detail',
        hideInMenu: true,
        requiresAuth: true,
      },
    },
    {
      path: 'execution/history',
      name: 'WorkflowExecutionHistory',
      component: () => import('@/views/workflow/execution-history.vue'),
      meta: {
        locale: 'menu.develop.workflow.execution',
        requiresAuth: true,
        roles: ['*'],
        icon: 'icon-history',
        iconColor: '#E68A1E',
        order: 15,
        hideInMenu: true,
      },
    },
    {
      path: 'execution/detail',
      name: 'WorkflowExecutionDetail',
      component: () => import('@/views/workflow/execution-detail.vue'),
      meta: {
        locale: 'menu.develop.workflow.executionDetail',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    {
      path: 'tool',
      name: 'ToolIndex',
      component: () => import('@/views/my-tools/index.vue'),
      meta: {
        locale: 'menu.develop.tool.index',
        requiresAuth: true,
        roles: ['*'],
        order: 20,
        icon: 'icon-my-tools',
      },
    },
    {
      path: 'tool/detail',
      name: 'ToolDetail',
      component: () => import('@/views/tool-detail/index.vue'),
      meta: {
        locale: 'menu.develop.tool.detail',
        hideInMenu: true,
        requiresAuth: true,
      },
    },
    {
      path: 'configuration',
      name: 'ConfigurationIndex',
      component: () => import('@/views/configuration/index.vue'),
      meta: {
        locale: 'menu.develop.configuration',
        requiresAuth: true,
        roles: ['*'],
        order: 30,
        icon: 'icon-configuration',
      },
    },
    // {
    //   path: 'scheduler/tasks',
    //   name: 'SchedulerTasks',
    //   component: () => import('@/views/workflow/scheduler-tasks.vue'),
    //   meta: {
    //     locale: 'menu.develop.scheduler',
    //     requiresAuth: true,
    //     roles: ['*'],
    //     order: 40,
    //     icon: 'icon-schedule',
    //     iconColor: '#722ED1',
    //   },
    // },
  ],
};

export default ROUTERS;
